/**
 * Campaign SS26 — Starting 11 grid modal + mobile FAB.
 */
(function () {
  if (window.__campaignSS26Bundle) return;
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function getFocusable(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  function trapFocus(e, dialog) {
    var list = getFocusable(dialog);
    if (list.length === 0) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function findBlock(blocks, id) {
    var sid = id != null ? String(id).trim() : '';
    for (var i = 0; i < blocks.length; i++) {
      if (String(blocks[i].id) === sid) return blocks[i];
    }
    return blocks[0] || null;
  }

  function productHasStorefrontUrl(p) {
    return !!(p && typeof p.url === 'string' && String(p.url).trim());
  }

  function portraitUrlEqual(a, b) {
    if (!a || !b) return false;
    try {
      return new URL(String(a), document.baseURI).href === new URL(String(b), document.baseURI).href;
    } catch (e) {
      return String(a) === String(b);
    }
  }

  /**
   * When switching athletes while the dialog stays open, changing img.src alone leaves the
   * previous bitmap visible until decode — reads as a flash. Hide until load/error.
   */
  function setModalPortraitImage(img, portraitUrl, name) {
    if (!img) return;
    var next = portraitUrl != null ? String(portraitUrl).trim() : '';
    if (!next) {
      if (img._campaignPortraitSwapClear) {
        img._campaignPortraitSwapClear();
        img._campaignPortraitSwapClear = null;
      }
      img.removeAttribute('src');
      img.alt = '';
      img.style.display = 'none';
      img.style.removeProperty('opacity');
      img.style.removeProperty('transition');
      return;
    }
    img.style.removeProperty('display');
    var prevSrc = img.getAttribute('src') || '';
    if (portraitUrlEqual(prevSrc, next)) {
      img.alt = name ? name + ' portrait' : '';
      return;
    }
    if (img._campaignPortraitSwapClear) {
      img._campaignPortraitSwapClear();
      img._campaignPortraitSwapClear = null;
    }
    img.style.opacity = '0';
    img.style.transition = 'none';
    img.alt = name ? name + ' portrait' : '';
    function reveal() {
      img.removeEventListener('load', reveal);
      img.removeEventListener('error', reveal);
      img._campaignPortraitSwapClear = null;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          img.style.opacity = '1';
          img.style.removeProperty('transition');
        });
      });
    }
    img.addEventListener('load', reveal);
    img.addEventListener('error', reveal);
    img._campaignPortraitSwapClear = function () {
      img.removeEventListener('load', reveal);
      img.removeEventListener('error', reveal);
    };
    img.src = next;
  }

  function fillModal(dialog, data) {
    if (!data) return;
    var img = dialog.querySelector('[data-campaign-modal-image]');
    var tag = dialog.querySelector('[data-campaign-modal-tagline]');
    var name = dialog.querySelector('[data-campaign-modal-name]');
    var bio = dialog.querySelector('[data-campaign-modal-bio]');
    var products = dialog.querySelector('[data-campaign-modal-products]');

    if (img) {
      var portraitUrl = data.portrait != null ? String(data.portrait).trim() : '';
      setModalPortraitImage(img, portraitUrl, data.name || '');
    }
    if (tag) tag.textContent = data.tagline || '';
    if (name) name.textContent = data.name || '';
    if (bio) {
      var bioSrc = data.id != null && document.getElementById('campaign-ss26-modal-body-' + data.id);
      bio.innerHTML = bioSrc ? bioSrc.innerHTML : data.bio || '';
    }

    var hasPortrait = !!(data.portrait && String(data.portrait).trim());
    var hasProducts =
      productHasStorefrontUrl(data.product_a) || productHasStorefrontUrl(data.product_b);
    dialog.classList.toggle('campaign-ss26-modal--no-portrait', !hasPortrait);
    dialog.classList.toggle('campaign-ss26-modal--no-products', !hasProducts);

    if (products) {
      products.innerHTML = '';
      [data.product_a, data.product_b].forEach(function (p) {
        if (!p || !p.url) return;
        var article = document.createElement('article');
        article.className = 'campaign-ss26-modal__product';
        var a = document.createElement('a');
        a.className = 'campaign-ss26-modal__product-link';
        a.href = p.url;
        if (p.image) {
          var thumb = document.createElement('div');
          thumb.className = 'campaign-ss26-modal__product-thumb';
          var im = document.createElement('img');
          im.src = p.image;
          im.alt = p.title ? p.title + ' product image' : '';
          im.loading = 'eager';
          thumb.appendChild(im);
          a.appendChild(thumb);
        }
        var meta = document.createElement('span');
        meta.className = 'campaign-ss26-modal__product-meta';
        var title = document.createElement('span');
        title.className = 'campaign-ss26-modal__product-title';
        title.textContent = p.title || '';
        var price = document.createElement('span');
        price.className = 'campaign-ss26-modal__product-price';
        price.textContent = p.price || '';
        meta.appendChild(title);
        meta.appendChild(price);
        a.appendChild(meta);
        article.appendChild(a);
        products.appendChild(article);
      });
    }
  }

  function wireDialog(dialog) {
    var keyHandler = function (e) {
      trapFocus(e, dialog);
    };
    dialog.addEventListener('keydown', keyHandler);
    return keyHandler;
  }

  function initSection(sectionEl) {
    if (sectionEl.getAttribute('data-ss26-inited') === '1') return;

    var dialog = sectionEl.querySelector('.campaign-ss26-modal');
    var dataScript =
      sectionEl.querySelector('script[type="application/json"].campaign-ss26-data') ||
      sectionEl.querySelector('script.campaign-ss26-data');
    if (!dialog || !dataScript) {
      console.warn('[Campaign SS26] Missing dialog or JSON script inside [data-campaign-section].');
      return;
    }

    var blocks;
    try {
      blocks = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error(
        '[Campaign SS26] Invalid JSON in script.campaign-ss26-data — modal will not open.',
        e,
        dataScript.textContent ? dataScript.textContent.slice(0, 500) : ''
      );
      return;
    }
    if (!blocks || !blocks.length) return;

    var lastId = blocks[0].id;
    sectionEl._campaignLastId = lastId;

    wireDialog(dialog);

    function getPageScrollY() {
      return (
        window.pageYOffset ||
        (document.scrollingElement && document.scrollingElement.scrollTop) ||
        document.documentElement.scrollTop ||
        0
      );
    }

    function restorePageScrollY(y) {
      if (typeof y !== 'number' || y < 0) return;
      function apply() {
        window.scrollTo({ top: y, left: 0, behavior: 'auto' });
        if (document.scrollingElement) {
          try {
            document.scrollingElement.scrollTop = y;
          } catch (err) {}
        }
        if (document.body) {
          try {
            document.body.scrollTop = y;
          } catch (err2) {}
        }
        try {
          document.documentElement.scrollTop = y;
        } catch (err3) {}
      }
      apply();
      window.requestAnimationFrame(function () {
        apply();
        window.requestAnimationFrame(apply);
      });
      window.setTimeout(apply, 0);
      window.setTimeout(apply, 50);
      window.setTimeout(apply, 150);
    }

    function cleanupClosedDialog() {
      if (dialog._campaignScrollResetIds && dialog._campaignScrollResetIds.length) {
        dialog._campaignScrollResetIds.forEach(function (id) {
          clearTimeout(id);
        });
        dialog._campaignScrollResetIds = null;
      }
      var lockY = sectionEl._campaignLockPageScrollY;
      sectionEl._campaignLockPageScrollY = null;
      document.documentElement.classList.remove('campaign-ss26-modal-open');
      dialog.classList.remove('campaign-ss26-modal--no-portrait', 'campaign-ss26-modal--no-products');
      dialog.style.cssText = '';
      var pf = dialog._campaignPrevFocus;
      dialog._campaignPrevFocus = null;
      // Do not re-focus the tile + button: :focus-within would keep the overlay visible after close.
      if (pf && typeof pf.blur === 'function') pf.blur();
      var fabEl = sectionEl.querySelector('[data-campaign-fab]');
      if (fabEl && typeof fabEl.blur === 'function') fabEl.blur();
      window.setTimeout(function () {
        if (fabEl && document.activeElement === fabEl && typeof fabEl.blur === 'function') {
          fabEl.blur();
        }
      }, 0);

      // Restore page scroll after closing — must run after html overflow unlock (see restorePageScrollY).
      if (typeof lockY === 'number' && lockY >= 0) {
        window.requestAnimationFrame(function () {
          restorePageScrollY(lockY);
          window.setTimeout(function () {
            restorePageScrollY(lockY);
          }, 0);
        });
      }
    }

    dialog.addEventListener('close', cleanupClosedDialog);

    function openDialogDOM(dialog) {
      document.documentElement.classList.add('campaign-ss26-modal-open');
      if (typeof dialog.showModal === 'function') {
        try {
          dialog.showModal();
          return true;
        } catch (err) {
          /* fall through */
        }
      }
      dialog.setAttribute('open', '');
      dialog.style.position = 'fixed';
      dialog.style.inset = '0';
      dialog.style.width = '100%';
      dialog.style.height = '100dvh';
      dialog.style.maxWidth = '100%';
      dialog.style.maxHeight = '100dvh';
      dialog.style.margin = '0';
      dialog.style.padding = '0';
      dialog.style.border = 'none';
      dialog.style.background = 'transparent';
      dialog.style.zIndex = '2147483000';
      return true;
    }

    function openForId(id, triggerEl) {
      var data = findBlock(blocks, id);
      if (!data) return;
      sectionEl._campaignLockPageScrollY = getPageScrollY();
      lastId = data.id;
      sectionEl._campaignLastId = lastId;
      dialog._campaignPrevFocus = triggerEl || document.activeElement;
      fillModal(dialog, data);
      openDialogDOM(dialog);
      var panelEl = dialog.querySelector('.campaign-ss26-modal__panel');
      function resetModalScroll() {
        dialog.scrollTop = 0;
        if (panelEl) panelEl.scrollTop = 0;
      }
      if (dialog._campaignScrollResetIds && dialog._campaignScrollResetIds.length) {
        dialog._campaignScrollResetIds.forEach(function (id) {
          clearTimeout(id);
        });
      }
      resetModalScroll();
      dialog._campaignScrollResetIds = [0, 80, 200, 450, 900].map(function (ms) {
        return setTimeout(resetModalScroll, ms);
      });
      window.requestAnimationFrame(function () {
        resetModalScroll();
        window.requestAnimationFrame(resetModalScroll);
      });
      var closeBtn = dialog.querySelector('.campaign-ss26-modal__close');
      function focusNoScroll(el) {
        if (!el || typeof el.focus !== 'function') return;
        try {
          el.focus({ preventScroll: true });
        } catch (err) {
          el.focus();
        }
      }
      if (closeBtn) focusNoScroll(closeBtn);
      else {
        var f = getFocusable(dialog)[0];
        if (f) focusNoScroll(f);
      }

      function bumpPortraitIntoView() {
        if (
          !dialog.classList.contains('campaign-ss26-modal--no-products') ||
          dialog.classList.contains('campaign-ss26-modal--no-portrait')
        ) {
          return;
        }
        var media = dialog.querySelector('.campaign-ss26-modal__media');
        var modalImg = dialog.querySelector('[data-campaign-modal-image]');
        if (!media) return;
        function run() {
          try {
            media.scrollIntoView({ block: 'start', behavior: 'instant', inline: 'nearest' });
          } catch (err) {}
          if (panelEl) {
            try {
              panelEl.scrollTop = 0;
            } catch (err2) {}
          }
        }
        window.requestAnimationFrame(function () {
          run();
          window.requestAnimationFrame(run);
        });
        window.setTimeout(run, 80);
        window.setTimeout(run, 350);
        if (modalImg && !modalImg.complete) {
          modalImg.addEventListener(
            'load',
            function onPortraitLoad() {
              modalImg.removeEventListener('load', onPortraitLoad);
              run();
            },
            { once: true }
          );
        }
      }
      bumpPortraitIntoView();
    }

    sectionEl._campaignOpenForId = openForId;

    var fab = sectionEl.querySelector('[data-campaign-fab]');
    if (fab) {
      fab.addEventListener('click', function (e) {
        e.preventDefault();
        openForId(sectionEl._campaignLastId != null ? sectionEl._campaignLastId : lastId, fab);
      });
    }

    var grid = sectionEl.querySelector('.campaign-ss26-grid');
    function blurOtherTileButtons(activeCard) {
      if (!grid) return;
      grid.querySelectorAll('.campaign-ss26-grid__card').forEach(function (other) {
        if (activeCard && other === activeCard) return;
        var openBtn = other.querySelector('[data-campaign-open]');
        if (openBtn && document.activeElement === openBtn && typeof openBtn.blur === 'function') {
          openBtn.blur();
        }
      });
    }

    if (grid) {
      grid.addEventListener(
        'mouseover',
        function (e) {
          var card = e.target.closest && e.target.closest('.campaign-ss26-grid__card');
          if (!card || !grid.contains(card)) return;
          blurOtherTileButtons(card);
        },
        true
      );

      grid.addEventListener(
        'focusin',
        function (e) {
          var t = e.target;
          if (!t.closest || !t.closest('[data-campaign-open]')) return;
          var card = t.closest('.campaign-ss26-grid__card');
          if (!card || !grid.contains(card)) return;
          blurOtherTileButtons(card);
        },
        true
      );
    }

    sectionEl.addEventListener('mouseleave', function (e) {
      if (e.relatedTarget && sectionEl.contains(e.relatedTarget)) return;
      sectionEl.querySelectorAll('[data-campaign-open]').forEach(function (btn) {
        if (document.activeElement === btn && typeof btn.blur === 'function') btn.blur();
      });
    });

    sectionEl.setAttribute('data-ss26-inited', '1');

    dialog.querySelectorAll('[data-campaign-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof dialog.close === 'function') {
          try {
            dialog.close();
            return;
          } catch (err2) {
            /* fall through */
          }
        }
        dialog.removeAttribute('open');
        cleanupClosedDialog();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-campaign-section]').forEach(initSection);
  }

  function delegatedClick(e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-campaign-open]');
    if (!btn) return;
    var section = btn.closest('[data-campaign-section]');
    if (!section) return;
    if (section.getAttribute('data-ss26-inited') !== '1') initSection(section);
    if (typeof section._campaignOpenForId !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    var rawId = btn.getAttribute('data-campaign-open');
    section._campaignOpenForId(rawId != null ? String(rawId).trim() : rawId, btn);
  }

  document.addEventListener('click', delegatedClick, true);
  window.__campaignSS26Bundle = true;

  function bootOrRetry() {
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOrRetry);
  } else {
    bootOrRetry();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-campaign-section]').forEach(function (el) {
      if (el.getAttribute('data-ss26-inited') !== '1') initSection(el);
    });
  });

  /**
   * Paste in DevTools console on the campaign page if GET THE LOOK does nothing:
   *   __campaignSS26Diagnostics()
   */
  window.__campaignSS26Diagnostics = function () {
    var sections = document.querySelectorAll('[data-campaign-section]');
    console.log('[Campaign SS26] sections found:', sections.length);
    sections.forEach(function (s, i) {
      var script = s.querySelector('script.campaign-ss26-data');
      console.log(
        '[Campaign SS26] section',
        i,
        'data-ss26-inited=',
        s.getAttribute('data-ss26-inited'),
        '_campaignOpenForId=',
        typeof s._campaignOpenForId
      );
      if (script) {
        try {
          var parsed = JSON.parse(script.textContent);
          console.log('[Campaign SS26] JSON OK, blocks:', parsed.length, parsed);
        } catch (err) {
          console.error('[Campaign SS26] JSON PARSE FAILED', err);
          console.log('First 800 chars:', script.textContent.slice(0, 800));
        }
      } else {
        console.warn('[Campaign SS26] Missing script.campaign-ss26-data');
      }
      var opens = s.querySelectorAll('[data-campaign-open]');
      console.log(
        '[Campaign SS26] [data-campaign-open] count:',
        opens.length,
        Array.prototype.map.call(opens, function (b) {
          return b.getAttribute('data-campaign-open');
        })
      );
      var dialog = s.querySelector('dialog.campaign-ss26-modal');
      console.log('[Campaign SS26] dialog.showModal:', dialog && typeof dialog.showModal);
    });
    console.log(
      '[Campaign SS26] Manual test (replace BLOCK_ID):',
      'document.querySelector("[data-campaign-section]")._campaignOpenForId("BLOCK_ID", document.activeElement)'
    );
  };
})();
